import Vue from 'vue'
import Router from 'vue-router'

import store from './store'
import { fnCheckMission } from './utils'

import Home from './pages/Home'
import Login from './pages/Login'
import Logout from './pages/Logout'
import Profile from './pages/Profile'
import Role from './pages/role/Role'
import Account from './pages/account/Account'
import Banner from './pages/banner/Banner'
import User from './pages/user/User'
import Post from './pages/post/Post'
import Report from './pages/report/Report'
import Gift from './pages/gift/Gift'
import Topic from './pages/topic/Topic'
import Order from './pages/order/Order'
import HashTag from './pages/hashtag/HashTag'
import Push from './pages/push/Push'
import Tracking from './pages/tracking/Tracking'
import Setting from './pages/setting/Setting'
import Discovery from './pages/discovery/Discovery'
import Mint from './pages/mint/Mint'

Vue.use(Router)

const router = new Router({
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
			props: {
				auth: true
			}
		},
		{
			path: '/role',
			name: 'role',
			component: Role,
			props: {
				auth: true,
				mission: [{ m: store.state.ROLE, p: store.state.READ }]
			}
		},
		{
			path: '/account',
			name: 'account',
			component: Account,
			props: {
				auth: true,
				mission: [{ m: store.state.ACCOUNT, p: store.state.READ }]
			}
		},
		{
			path: '/user',
			name: 'user',
			component: User,
			props: {
				auth: true,
				mission: [{ m: store.state.USER, p: store.state.READ }]
			}
		},
		{
			path: '/hashtag',
			name: 'hashtag',
			component: HashTag,
			props: {
				auth: true,
				mission: [{ m: store.state.HASHTAG, p: store.state.READ }]
			}
		},
		{
			path: '/topic',
			name: 'topic',
			component: Topic,
			props: {
				auth: true,
				mission: [{ m: store.state.TOPIC, p: store.state.READ }]
			}
		},
		{
			path: '/push',
			name: 'push',
			component: Push,
			props: {
				auth: true,
				mission: [{ m: store.state.PUSH, p: store.state.READ }]
			}
		},
		{
			path: '/banner',
			name: 'banner',
			component: Banner,
			props: {
				auth: true,
				mission: [{ m: store.state.BANNER, p: store.state.READ }]
			}
		},
		{
			path: '/post',
			name: 'post',
			component: Post,
			props: {
				auth: true,
				mission: [{ m: store.state.POST, p: store.state.READ }]
			}
		},
		{
			path: '/report',
			name: 'report',
			component: Report,
			props: {
				auth: true,
				mission: [{ m: store.state.POST, p: store.state.READ }]
			}
		},
		{
			path: '/gift',
			name: 'gift',
			component: Gift,
			props: {
				auth: true,
				mission: [{ m: store.state.GIFT, p: store.state.READ }]
			}
		},
		{
			path: '/discovery',
			name: 'discovery',
			component: Discovery,
			props: {
				auth: true,
				mission: [{ m: store.state.DISCOVERY, p: store.state.READ }]
			}
		},
		{
			path: '/order',
			name: 'order',
			component: Order,
			props: {
				auth: true,
				mission: [{ m: store.state.ORDER, p: store.state.READ }]
			}
		},
		{
			path: '/tracking',
			name: 'tracking',
			component: Tracking,
			props: {
				auth: true,
				mission: [{ m: store.state.TRACKING, p: store.state.READ }]
			}
		},
		{
			path: '/setting',
			name: 'setting',
			component: Setting,
			props: {
				auth: true,
				mission: [{ m: store.state.SETTING, p: store.state.READ }]
			}
		},
		{
			path: '/mint',
			name: 'mint',
			component: Mint,
			props: {
				auth: true,
				mission: [{ m: store.state.MINT, p: store.state.READ }]
			}
		},
		{
			path: '/login',
			name: 'login',
			component: Login,
			props: {
				auth: false
			}
		},
		{
			path: '/logout',
			name: 'logout',
			component: Logout,
			props: {
				auth: true
			}
		},
		{
			path: '/profile',
			name: 'profile',
			component: Profile,
			props: {
				auth: true
			}
		},
		{
			path: '*',
			redirect: '/',
			props: {
				auth: true
			}
		}
	]
})

router.beforeEach(async (to, from, next) => {
	await store.dispatch('fnGetMe')
	const { auth, mission } = to.matched[0].props.default
	if (auth) {
		if (!store.state.Token.access_token) return store.dispatch('fnLogout')
		if (mission && !fnCheckMission(store.state.Session, mission)) {
			return next('/')
		}
	} else if (store.state.IsLogin) {
		return next('/')
	}
	next()
})

export default router
